import { Link } from "react-router-dom";
import { NAV_KEYS, useLang } from "@/i18n";

export const Footer = () => {
  const { t, to } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#1A2522] text-[#F8F6F0]">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-16 sm:py-20">
        <div className="flex flex-col lg:flex-row lg:justify-between gap-10">
          <div>
            <p className="font-serif text-3xl tracking-tight">ONKOLIFE</p>
            <p className="mt-2 text-sm text-[#A8B5B0]">{t.footer.name}</p>
            <p className="text-sm text-[#A8B5B0]">{t.footer.specialty}</p>
          </div>
          <nav className="grid grid-cols-2 sm:grid-cols-3 gap-x-10 gap-y-3" data-testid="footer-nav">
            {NAV_KEYS.map((k) => (
              <Link key={k} to={to(k)} data-testid={`footer-link-${k}`} className="text-[12px] tracking-[0.18em] uppercase text-[#A8B5B0] hover:text-[#F8F6F0] transition-colors">
                {t.nav[k]}
              </Link>
            ))}
          </nav>
        </div>
        <div className="mt-14 pt-8 border-t border-[#374F49]/60 flex flex-col sm:flex-row sm:justify-between gap-4 text-[12px] tracking-[0.18em] uppercase text-[#A8B5B0]">
          <p>© {new Date().getFullYear()} ONKOLIFE — Prof. Piotr Wysocki</p>
          <p>{t.footer.location}</p>
        </div>
      </div>
    </footer>
  );
};
